import { cabinUpgrade } from '@eti/products';
import type {
  Bound,
  TransformedSegment,
  UpgradeTypePerBound,
} from '../../../../../../../widgets/trip-itinerary/models';
import type { AddOnOrdersType } from '../../../../../models';

export const transformSegments = (segments: Bound['segments']): TransformedSegment[] => {
  return segments
    .map((segment, i, allSegments) => {
      if (segment.__typename === 'EventSegment') {
        const nextSegment = allSegments[i + 1];
        const previousSegment = allSegments[i - 1];

        if (
          nextSegment?.__typename === 'TripSegment' &&
          previousSegment?.__typename === 'TripSegment'
        ) {
          return {
            ...segment,
            nextAirport: nextSegment.origin.name,
            nextDeparture: nextSegment.departuredAt,
            previousArrival: previousSegment.arrivedAt,
            previousAirport: previousSegment.destination.name,
            previousDestination: previousSegment.destination.cityName,
          };
        }
      }

      if (segment.__typename === 'TripSegment') {
        return segment;
      }

      return null;
    })
    .filter((segment): segment is TransformedSegment => Boolean(segment?.__typename));
};

export const getSegmentsCabinUpgradePrices = (
  addOnOrders: AddOnOrdersType,
): UpgradeTypePerBound[] | null => {
  const cabinUpgradeProduct = addOnOrders
    .flatMap((order) => order.extraProducts)
    .find((extraProduct) => extraProduct && Number(extraProduct.id) === cabinUpgrade.id);

  if (
    cabinUpgradeProduct?.buySpecification?.__typename === 'BuySpecificationCartTravelerCabinUpgrade'
  ) {
    return cabinUpgradeProduct.buySpecification.segmentsCabinUpgradePrices?.filter(
      (segment) => segment !== null,
    );
  }
  return null;
};
